export default "__VITE_ASSET__CqLcafbA__";